module.exports = __webpack_public_path__ + "static/media/Design1-mobile.1acbb480.svg";